import { Component, OnInit, AfterViewInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
// import * as XLSX from 'xlsx';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResetPasswordComponent } from '../../snackbars/reset-password/reset-password.component';
import { BanUserComponent } from '../../snackbars/ban-user/ban-user.component';
import { ExternalUserModel, UserModel } from 'src/app/models/common/usermodel';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, startWith, Subject } from 'rxjs';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { BanUserModel } from 'src/app/models/common/ban-user-model';
import { ForceResetPasswordModel } from 'src/app/models/common/reset-password-model';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';


type AOA = any[][];
@Component({
    selector: 'user-table',
    templateUrl: './user-table.component.html',
    styleUrls: ['./user-table.component.scss', '../master-data.scss'],

})
export class UserTableComponent implements OnInit, AfterViewInit {

    base_url = environment.baseApiUrl;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchTerm = '';
    update: boolean = false;
    loading: boolean = true;
    internalUserList: MatTableDataSource<UserModel>;
    externalUserList: MatTableDataSource<ExternalUserModel>;
    banningUser: BanUserModel;
    resetPassword: ForceResetPasswordModel;
    displayedColumns = ['name', 'email', 'department', 'role', 'status','action'];
    displayedColumns1 = ['name', 'email', 'company', 'mobile_number', 'action'];
    searchText = new BehaviorSubject<string>('');

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    userValue: string = "internal_user";
    isShown!: boolean;
    isBulk!: boolean;
    isDatabase!: boolean;

    Canvas: string = "Canvas";
    data1: AOA = [[1, 2], [3, 4]];
    fileName1: string = 'dataFormat.xlsx';

    @Output()
    canvas = new EventEmitter<string>();

    @Output()
    patchUserForm = new EventEmitter();

    @Output()
    viewUserForm = new EventEmitter();

    defaultErrorObj: any = {};

    @Output()
    clearErrorsOnFormOpen = new EventEmitter();

    @Input()
    forceRefresh = new Subject();

    openUserSidePanel() {
        this.clearErrorsOnFormOpen.emit(this.defaultErrorObj = {})
        document.getElementById("mySidepanel")!.style.width = "493px";
        document.getElementById("mySidepanel")!.style.boxShadow = "0 0 0 99999px rgba(0, 0, 0, .7)";
        this.Canvas = " Canvas setCanvas";
        this.isBulk = false;
        this.canvas.emit(this.Canvas);
    }

    Show() {
        this.isShown = true;
    }
    // errorImg(a: any) {
    //   this.src = 'assets/images/icons/error.svg'
    // }
    export(): void {

        /* generate worksheet */
        // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data1);

        // /* generate workbook and add the worksheet */
        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // /* save to file */
        // XLSX.writeFile(wb, this.fileName1);
    }
    noShow() {
        this.isShown = false;
    }

    @ViewChild('title') title: any;
    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    onMouseMove(e: any) {
        this.dropped = true;
        if (e.clientX < (this.screenWidth / 2)) {//right shadow
            this.shadowX = 5;
        } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
            this.shadowX = -5;
        }
        if (e.clientY > (this.screenHeight / 2)) {//top shadow
            this.shadowY = -4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
            this.shadowY = 4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        }
    }


    back() {
        this.route.navigateByUrl('dashboards/user-dashboard');
    }

    constructor(
        private _snackBar: MatSnackBar,
        private userService: UserMasterApiService,
        private dialog: MatDialog,
        private route: Router
    ) {
        this.screenHeight = (window.screen.height)
        this.screenWidth = (window.screen.width)
    }

    ngOnInit() {
        this.isShown = true;// add button view
        this.isDatabase = true;// to show user database table
        this.isBulk = false; // show bulk upload form
        // this.changer;

        this.refreshUserInformationList();
        this.refreshExternalUserList();
        this.forceRefresh.subscribe(item => {
            console.log(item)
            this.refreshUserInformationList();
            this.refreshExternalUserList();
        })

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                if (this.userValue == 'internal_user') {
                    this.refreshUserInformationList(this.pageSize, this.pageIndex, searchText);
                }
                if (this.userValue == 'external_user') {
                    this.refreshExternalUserList(this.pageSize, this.pageIndex, searchText);
                }
            })
        ).subscribe();
    }
    /**
       * Set the paginator and sort after the view init since this component will
       * be able to query its view for the initialized paginator and sort.
       */
    ngAfterViewInit() {
        if (this.internalUserList != null || this.internalUserList != undefined) {
            this.internalUserList.paginator = this.paginator;
            this.internalUserList.sort = this.sort;
        }
    }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
        this.update = true;
        // This example uses English messages. If your application supports
        // multiple language, you would internationalize these strings.
        // Furthermore, you can customize the message to add additional
        // details about the values being sorted.

        // if (sortState.direction) {
        //   this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
        // } else {
        //   this._liveAnnouncer.announce('Sorting cleared');
        // }
        if (this.userValue == 'internal_user') {
            switch (sortState.direction) {
                case 'asc':
                    if (sortState.active == 'name') {
                        this.refreshUserInformationList(this.pageSize, this.pageIndex, '', `first_${sortState.active}`);
                    } else {
                        this.refreshUserInformationList(this.pageSize, this.pageIndex, '', sortState.active);
                    }
                    break;

                case 'desc':
                    if (sortState.active == 'name') {
                        this.refreshUserInformationList(this.pageSize, this.pageIndex, '', `-first_${sortState.active}`);
                    } else {
                        this.refreshUserInformationList(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
                    }
                    break;

                default:
                    this.refreshUserInformationList(this.pageSize, this.pageIndex);
            }
        }
        if (this.userValue == 'external_user') {
            switch (sortState.direction) {
                case 'asc':
                    if (sortState.active == 'name') {
                        this.refreshExternalUserList(this.pageSize, this.pageIndex, '', `first_${sortState.active}`);
                    } else {
                        this.refreshExternalUserList(this.pageSize, this.pageIndex, '', sortState.active);
                    }
                    break;

                case 'desc':
                    if (sortState.active == 'name') {
                        this.refreshExternalUserList(this.pageSize, this.pageIndex, '', `-first_${sortState.active}`);
                    } else {
                        this.refreshExternalUserList(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
                    }
                    break;

                default:
                    this.refreshExternalUserList(this.pageSize, this.pageIndex);
            }
        }
    }

    applyFilter(event) {
        this.update = true;
        this.pageIndex = 0;
        this.searchText.next(event);
    }

    // userList: BackendListModel<UserModel>;
    refreshUserInformationList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.userService.getUser(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.internalUserList = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.update = false;
                this.loading = false;
            },
            error: error => {
                console.log("User table list error", error)
                return error;
            }
        })
    }

    refreshExternalUserList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.userService.getExternalUser(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.externalUserList = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.update = false;
                this.loading = false;
            },
            error: error => {
                console.log("User table list error", error)
                return error;
            }
        })
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        if (this.userValue == 'internal_user') {
            this.refreshUserInformationList(this.pageSize, this.pageIndex);
        }
        if (this.userValue == 'external_user') {
            this.refreshExternalUserList(this.pageSize, this.pageIndex);
        }
    }

    editUser(user) {
        this.openUserSidePanel()
        this.patchUserForm.emit(user)
        this.viewUserForm.emit(true);
    }

    viewUser(user) {
        this.openUserSidePanel()
        this.patchUserForm.emit(user);
        this.viewUserForm.emit(false);
    }

    banSpecificUser(data) {
        this.userService.banUser(data).subscribe({
            next: response => {
                this._snackBar.openFromComponent(BanUserComponent, {
                    duration: 4000,
                    panelClass: ['success-snackbar'],
                    data: {
                        description: `${data.is_banned == true ? 'User is BANNED successfully' : 'Ban has been REVOKED'}`,
                        image: `${data.is_banned == true ? '/assets/images/icons/snackbar/ban-user1.svg' : '/assets/images/icons/snackbar/active-user.svg'}`
                    }
                });
                this.banningUser = null;
                return response;
            },
            error: error => {
                this._snackBar.open(error.error.user_id[0], 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log(error);
                return error;
            }
        });
    }

    clickedOnReset: boolean = false;
    resetUserPassword(data) {
        this.userService.resetPassword(data).subscribe({
            next: response => {
                this._snackBar.openFromComponent(ResetPasswordComponent, {
                    duration: 3000,
                    panelClass: ['success-snackbar']
                });
                this.clickedOnReset = true;
                return response;
            },
            error: error => {
                this._snackBar.open("Reset Failed", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log(error);
                return error;
            }
        })
    }

    // Ban User
    banUser(data, toBan: boolean) {
        this.banningUser = { user_id: data.user_id, is_banned: toBan }
        this.openBanWarningDialog(`${data.first_name} ${data.last_name}`, `Do you really want to ${toBan == true ? 'BAN' : 'Revoke BAN of'} this user?<br>Are you sure?`, 'Abort', 'Proceed');
    }

    resetPassUids = [];
    // Reset Password
    reset(data) {
        this.resetPassUids.push(data.id);
        this.resetPassword = { user_id: data.user_id }
        this.openResetPasswordWarningDialog(`${data.first_name} ${data.last_name}`, `Do you really want to Reset password of this user?<br>Are you sure?`, 'Abort', 'Proceed');
    }

    // Reset Password warning dialog
    openResetPasswordWarningDialog(label: string, temp, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: label, parent: this, description: temp, label1: action1, label2: action2, negativeAction: this.resetPasswordNegativeResponse, positiveAction: this.resetPasswordPositiveResponse }
        })
        dialogRef.afterClosed().subscribe((is_positive) => {
            if (is_positive == false || is_positive == undefined) {
                this.resetPassUids.pop();
            }
        });
    }

    // Action to Reset Password with respect to selection
    resetPasswordPositiveResponse(parent) {
        parent.resetUserPassword(parent.resetPassword)
        parent.refreshUserInformationList();
    }

    resetPasswordNegativeResponse(parent) {
        parent.resetPassword = null;
    }

    // Ban User warning dialog
    openBanWarningDialog(label: string, temp, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            data: { subTitle: label, parent: this, description: temp, label1: action1, label2: action2, negativeAction: this.banUserNegativeResponse, positiveAction: this.banUserPositiveResponse }
        })
        dialogRef.afterClosed().subscribe(is_positive => {
            if (is_positive == false || is_positive == undefined) {
                this.banningUser = null;
            }
        });
    }

    // Action to Ban User with respect to selection
    banUserPositiveResponse(parent) {
        if (parent.banningUser != null) {
            parent.banSpecificUser(parent.banningUser);
            parent.refreshUserInformationList();
        }
    }

    banUserNegativeResponse(parent) {
        if (parent.banningUser != null) {
            parent.banningUser = null;
        }
    }
}
